<ol class="rso-list" [class.rso-list--readonly]="readonly">
  @for (step of rows; track step.action; let i = $index, first = $first, last = $last) {
  <li class="rso-row" [class.rso-row--draggable]="!readonly" [class.rso-row--dragging]="dragIndex === i"
    [attr.draggable]="!readonly" (dragstart)="onDragStart(i, $event)" (dragover)="onDragOver(i, $event)"
    (drop)="onDrop($event)" (dragend)="onDragEnd()">
    @if (!readonly) {
    <span class="rso-grip" aria-hidden="true" title="Drag to reorder">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="9" cy="6" r="1.6"></circle><circle cx="15" cy="6" r="1.6"></circle>
        <circle cx="9" cy="12" r="1.6"></circle><circle cx="15" cy="12" r="1.6"></circle>
        <circle cx="9" cy="18" r="1.6"></circle><circle cx="15" cy="18" r="1.6"></circle>
      </svg>
    </span>
    }
    <span class="rso-num">{{ i + 1 }}</span>
    <!-- Same icon tile and accent as the action's row in the incident popup. -->
    <span class="sw-incident-action-icon rso-icon sw-incident-action--{{ accentClass[step.action] }}" aria-hidden="true">
      @switch (step.action) {
      @case ('speaker') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
      </svg>
      }
      @case ('emergency') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1.25 1.25 0 0 1 1.28-.3c1.13.38 2.35.58 3.57.58a1.25 1.25 0 0 1 1.25 1.25v3.5A1.25 1.25 0 0 1 20.25 21C10.72 21 3 13.28 3 3.75A1.25 1.25 0 0 1 4.25 2.5h3.5A1.25 1.25 0 0 1 9 3.75c0 1.23.2 2.44.58 3.57a1.25 1.25 0 0 1-.3 1.28l-2.68 2.2z">
        </path>
      </svg>
      }
      @case ('client_contact') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
      }
      @case ('client_notification') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
      </svg>
      }
      @case ('incident_report') {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <path d="M14 2v6h6"></path>
        <path d="M9 15h6"></path>
        <path d="M12 12v6"></path>
      </svg>
      }
      }
    </span>
    <span class="rso-label">{{ labels[step.action] }}</span>
    @if (!readonly) {
    <span class="rso-move" role="group" [attr.aria-label]="'Move ' + labels[step.action]">
      <button type="button" class="rso-move-btn" (click)="move(i, -1)" [disabled]="first"
        [attr.aria-label]="'Move ' + labels[step.action] + ' up'" title="Move up">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m18 15-6-6-6 6"></path></svg>
      </button>
      <button type="button" class="rso-move-btn" (click)="move(i, 1)" [disabled]="last"
        [attr.aria-label]="'Move ' + labels[step.action] + ' down'" title="Move down">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>
      </button>
    </span>
    @if (canRemove(step.action)) {
    <button type="button" class="rso-remove" (click)="removeStep(i)"
      [attr.aria-label]="'Remove ' + labels[step.action]" title="Remove this step">×</button>
    }
    }
  </li>
  }
</ol>

@if (manageSteps && !readonly && missingActions.length) {
<div class="rso-add" role="group" aria-label="Add a step">
  <span class="rso-add-label">Add a step</span>
  @for (action of missingActions; track action) {
  <button type="button" class="rso-add-btn" (click)="addStep(action)">+ {{ labels[action] }}</button>
  }
</div>
}
